
var reduxStore = require('redux');
var rootReducer = require('./rootReducer.js');

const store = reduxStore.createStore(rootReducer.reducer);

module.exports.getStore = function()
{
    return store;
}
